type LogLevel = 'info' | 'warn' | 'error' | 'log';

class Logger {
  private isDevelopment: boolean = import.meta.env.DEV;

  log(level: LogLevel | string, message: string, context?: any): void {
    const safeLevel = (['info', 'warn', 'error', 'log'] as string[]).includes(level)
      ? (level as LogLevel)
      : 'log';

    if (this.isDevelopment) {
      const logFn = (console as any)[safeLevel] || console.log;
      logFn(`[${safeLevel.toUpperCase()}] ${message}`, context || '');
    } else if (safeLevel === 'error') {
      console.error(message, context || '');
    }
  }

  info(message: string, context?: any): void { this.log('info', message, context); }
  warn(message: string, context?: any): void { this.log('warn', message, context); }
  error(message: string, context?: any): void { this.log('error', message, context); }
}

export const logger = new Logger();
